import {loadScriptOnce} from './utils';

// panel height elements
document.addEventListener('DOMContentLoaded', () => {
  loadScriptOnce('/local/templates/template3/public/js/vendor/jquery-3.2.1.min.js', function () {
    loadScriptOnce('/local/templates/template3/public/js/modules/jquery.viewportchecker.js', function () {
      const $ = window.jQuery || window.$;

      if (!$) return;

      if (typeof $.fn.viewportChecker !== 'function') {
        console.warn('viewportChecker plugin is not available');
        return;
      }

      let $panel = $('.panel'),
      $panelPointButton = $('.panel__point'),
      $panelAddress = $('.panel__transform.-address'),
      $footer = $('.footer'),
      classActive = '-is-active';

    if (!$panel.length && !$footer.length) return;

    function animateHeightPointButton(direction, footerHeight,) {

      if (!direction && !footerHeight) return;

      switch (direction) {
        case '-':
          $panelPointButton.toggleClass(classActive);
          $panelPointButton
            .finish()
            .animate({
                'height': '+' + footerHeight,
              }, 450
            );
          break;
        case '+':
          $panelPointButton
            .finish()
            .animate({
                'height': 0,
              }, 450,
              function () {
                $panelPointButton.toggleClass(classActive);
              }
            );
          break;
      }
    };

    function animateHeightAddress(direction, footerHeight) {

      if (!direction && !footerHeight) return;

      switch (direction) {
        case '-':
          $panelAddress
            .finish()
            .animate({
                "height": "-" + footerHeight
              }, 450
            );
          break;
        case '+':
          $panelAddress
            .finish()
            .animate({
                "height": "+" + footerHeight
              }, 450
            );
          break;
      }
    }

    function getDirection(action) {
      if (action === 'add' && !$panelPointButton.hasClass(classActive))
        return '-'
      else if (action === 'remove' && $panelPointButton.hasClass(classActive))
        return '+'
      return '';
    }

    if (window.innerWidth >= 992) {
      $footer.viewportChecker({
        offset: '-1%',
        classToAdd: '-show',
        repeat: true,
        callbackFunction: function (elem, action) {
          let $footerHeight = $footer.outerHeight(true);
          let $direction = getDirection(action);
          animateHeightAddress($direction, $footerHeight)

          if (window.matchMedia('(min-width: 992px)').matches
            && window.matchMedia('(min-height: 653px)').matches) {

            animateHeightPointButton($direction, $footerHeight);

          } else {
            $panelPointButton.removeAttr('style');
            $panelPointButton.removeClass(classActive);
          }
        }
      });
    }
  });
  });
});
